var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileNavHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.254,
    height: 13.57,
    viewBox: "0 0 13.254 13.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mobile_nav_home_icon",
    d: "M9.483,1.87a1.262,1.262,0,0,0-1.785,0L2.333,7.234a1.262,1.262,0,0,0-.37.893v3.042l8.41-8.41Zm1.559,1.559L9.257,5.214,12.693,8.65v6.42h1.262a1.262,1.262,0,0,0,1.262-1.262V8.127a1.262,1.262,0,0,0-.37-.893Zm.7,11.641V12.545H5.435V15.07Zm-7.258,0V9.984L1.963,12.508v1.3A1.262,1.262,0,0,0,3.226,15.07Z",
    transform: "translate(-1.963 -1.5)",
    fill: "#7c4dff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNavHomeIcon);
export default __webpack_public_path__ + "static/media/mobile_nav_home_icon.919f22fa3e48af076d24da661bef0738.svg";
export { ForwardRef as ReactComponent };